export const VIDEO_ACTIONS = {
  SET_STATE: "video/setState",
  GET_VIDEO: "video/getVideo",
  GET_VIDEO_BY_ID: "video/getVideoById",
  CREATE_VIDEO: "video/createVideo",
  UPDATE_VIDEO: "video/updateVideo",
  DELETE_VIDEO: "video/deleteVideo",
};
